
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export const useSessionCheck = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkSession = async () => {
      console.log("Checking auth session...");
      const { data: { session }, error } = await supabase.auth.getSession();
      
      if (error) {
        console.error("Session check error:", error);
        return;
      }
      
      // Si nous sommes sur la page d'authentification et qu'une session existe,
      // rediriger vers la page d'accueil
      if (session && window.location.pathname === '/auth') {
        console.log("Valid session found, redirecting to home");
        navigate("/");
      } else {
        console.log("No valid session found");
      }
    };

    checkSession();
  }, [navigate]);
};
